<template>
    <div>

        <a-card :loading="tableLoading" style="border-top-right-radius: 20px; border-top-left-radius: 20px"
            :bordered="false">
            <div class="actions">
                <div @click="redirectPreviousUrl"
                    style="font-size:20px;text-decoration: none;width:30%;line-height:30px;display:flex;cursor:pointer">
                    <p>
                        <a-icon style="font-size: 15px; margin-right: 8px;" type="arrow-left" />
                    </p>
                    <p>Go Back To Leads </p>
                </div>
                <div v-if="showButton">
                    <a-button @click="showConvertModal" class="ml-4"
                        style="border-raduis:6px; background: #fff;color:#0F3659">
                        Convert
                    </a-button>

                    <a-button @click="showLeadStatusModal" class="ml-4"
                        style="border-raduis:6px; background: #fff;color:#0F3659">
                        Update Status
                    </a-button>
                </div>
            </div>

            <div class="mt-3">
                <div class="container">
                    <div class="circular-div">
                        <img src="../../assets/img/profile-pic.png" alt="Company Image">
                    </div>
                    <div class="text-overlay">
                        <span class="company-name">{{ lead.accountName }} </span>
                        <span class="account-name">Acccount Type: <span>{{ lead.accountTypeLabel }}</span></span>
                    </div>
                </div>

            </div>
            <div class="card-container">
                <a-tabs type="card">
                    <a-tab-pane key="0">
                        <span slot="tab">
                           
                            Overview
                        </span>

                        <a-card :loading="tableLoading" :bordered="false">
                            <div>
                                <a-row>
                                    <a-col class="ml-4" :span="24">
                                        <div style="font-size: 12px">

                                            <a-row class="pb-2">
                                                <a-col :span="4">
                                                    <div>Lead Owner: </div>
                                                </a-col>
                                                <a-col :span="14">
                                                    <div>{{ lead.userName ? lead.userName : "N/A" }}</div>
                                                </a-col>
                                            </a-row>
                                            <a-row class="pb-2">
                                                <a-col :span="4">
                                                    <div>Email: </div>
                                                </a-col>
                                                <a-col :span="14">
                                                    <div>{{ lead.email ? lead.email : "N/A" }}</div>
                                                </a-col>
                                            </a-row>

                                            <a-row class="pb-2">
                                                <a-col :span="4">
                                                    <div>Phone Number: </div>
                                                </a-col>
                                                <a-col :span="14">
                                                    <div>{{ lead.phoneNumber ? lead.phoneNumber : "N/A" }}</div>
                                                </a-col>
                                            </a-row>
                                            <a-row class="pb-2">
                                                <a-col :span="4">
                                                    <div>Position: </div>
                                                </a-col>
                                                <a-col :span="14">
                                                    <div>{{ lead.position ? lead.position : "N/A" }}</div>
                                                </a-col>
                                            </a-row>
                                        </div>
                                    </a-col>
                                </a-row>
                                <hr />

                            </div>
                            <div>
                                <a-collapse v-model="activeKey" :bordered="false">
                                    <a-collapse-panel key="1" header="Hide Details">
                                        <div>
                                            <p
                                                style="display:flex;justify-content: start;margin-top: 10px;font-size:15px; color: #9197B3;">
                                                Lead Information
                                            </p>

                                            <div class="ml-4">
                                                <a-row style="font-size: 12px" :gutter="16">
                                                    <a-col :span="8">
                                                        <a-row :style="{ marginBottom: '16px' }">
                                                            <a-col :span="12">
                                                                <strong>Title:</strong>
                                                            </a-col>
                                                            <a-col :span="12">
                                                                <div>{{ lead.titleLabel ? lead.titleLabel : "N/A" }}
                                                                </div>
                                                            </a-col>
                                                        </a-row>
                                                        <a-row :style="{ marginBottom: '16px' }">
                                                            <a-col :span="12">
                                                                <strong>First Name:</strong>
                                                            </a-col>
                                                            <a-col :span="12">
                                                                <div>{{ lead.firstName ? lead.firstName : "N/A" }}
                                                                </div>
                                                            </a-col>
                                                        </a-row>
                                                        <a-row :style="{ marginBottom: '16px' }">
                                                            <a-col :span="12">
                                                                <strong>Last Name:</strong>
                                                            </a-col>
                                                            <a-col :span="12">
                                                                <p>
                                                                    {{ lead.lastName ? lead.lastName : "N/A" }}
                                                                </p>
                                                            </a-col>
                                                        </a-row>
                                                        <a-row :style="{ marginBottom: '16px' }">
                                                            <a-col :span="12">
                                                                <strong>Expected Revenue:</strong>
                                                            </a-col>
                                                            <a-col :span="12">
                                                                <div>GHS {{ lead.expectedRevenue ?
                                                                    lead.expectedRevenue.toLocaleString(undefined, {
                                                                    minimumFractionDigits: 2,
                                                                    })
                                                                    : "N/A" }}</div>
                                                            </a-col>
                                                        </a-row>
                                                        <a-row :style="{ marginBottom: '16px' }">
                                                            <a-col :span="12">
                                                                <strong>No. of Employees:</strong>
                                                            </a-col>
                                                            <a-col :span="12">
                                                                <p>
                                                                    {{ lead.employeeCount ? lead.employeeCount : "N/A"
                                                                    }}
                                                                </p>
                                                            </a-col>
                                                        </a-row>
                                                        <a-row :style="{ marginBottom: '16px' }">
                                                            <a-col :span="12">
                                                                <strong>Status:</strong>
                                                            </a-col>
                                                            <a-col :span="12">
                                                                <a-tag color="#2db7f5">
                                                                    {{ lead.statusLabel ? lead.statusLabel
                                                                    : "N/A" }}
                                                                </a-tag>
                                                            </a-col>
                                                        </a-row>
                                                    </a-col>
                                                    <a-col :span="8" :offset="4">
                                                        <a-row :style="{ marginBottom: '16px', fontSize: '12px' }">
                                                            <a-col :span="12">
                                                                <strong>Department:</strong>
                                                            </a-col>
                                                            <a-col :span="12">
                                                                <p>
                                                                    {{ lead.department ? lead.department
                                                                    : "N/A" }}
                                                                </p>
                                                            </a-col>
                                                        </a-row>
                                                        <a-row :style="{ marginBottom: '16px' }">
                                                            <a-col :span="12">
                                                                <strong>Source:</strong>
                                                            </a-col>
                                                            <a-col :span="12">
                                                                {{ lead.sourceLabel ? lead.sourceLabel
                                                                : "N/A" }}
                                                            </a-col>
                                                        </a-row>
                                                        <a-row :style="{ marginBottom: '16px' }">
                                                            <a-col :span="12">
                                                                <strong>District:</strong>
                                                            </a-col>
                                                            <a-col :span="12">
                                                                <div>{{ lead.districtName ? lead.districtName
                                                                    : "N/A" }}</div>
                                                            </a-col>
                                                        </a-row>
                                                        <a-row :style="{ marginBottom: '16px' }">
                                                            <a-col :span="12">
                                                                <strong>Email Opt:</strong>
                                                            </a-col>
                                                            <a-col :span="12">
                                                                <div v-if="lead.emailOpt">
                                                                    <a-switch default-checked checkedChildren=""
                                                                        unCheckedChildren="" @change="onEmailChange"
                                                                        @click="switchEmailStatus()" />
                                                                </div>
                                                                <div v-else>
                                                                    <a-switch checkedChildren="" unCheckedChildren=""
                                                                        @change="onEmailChange"
                                                                        @click="switchEmailStatus()" />
                                                                </div>
                                                            </a-col>
                                                        </a-row>
                                                        <a-row :style="{ marginBottom: '16px' }">
                                                            <a-col :span="12">
                                                                <strong>SMS Opt:</strong>
                                                            </a-col>
                                                            <a-col :span="12">
                                                                <div v-if="lead.smsOpt">
                                                                    <a-switch default-checked checkedChildren=""
                                                                        unCheckedChildren="" @change="onSmsChange"
                                                                        @click="switchSmsStatus()" />
                                                                </div>
                                                                <div v-else>
                                                                    <a-switch checkedChildren="" unCheckedChildren=""
                                                                        @change="onSmsChange"
                                                                        @click="switchSmsStatus()" />
                                                                </div>
                                                            </a-col>
                                                        </a-row>
                                                        <a-row :style="{ marginBottom: '16px' }">
                                                            <a-col :span="12">
                                                                <strong>Is Primary?:</strong>
                                                            </a-col>
                                                            <a-col :span="12">
                                                                <div v-if="lead.isPrimary">
                                                                    <a-switch default-checked checkedChildren=""
                                                                        unCheckedChildren="" @change="onPrimaryChange"
                                                                        @click="switchPrimaryStatus()" />
                                                                </div>
                                                                <div v-else>
                                                                    <a-switch checkedChildren="" unCheckedChildren=""
                                                                        @change="onPrimaryChange"
                                                                        @click="switchPrimaryStatus()" />
                                                                </div>
                                                            </a-col>
                                                        </a-row>
                                                    </a-col>
                                                </a-row>
                                            </div>

                                        </div>
                                        <div>
                                            <a-row style="font-size: 12px">
                                                <a-col :span="12">
                                                    <p
                                                        style="display:flex;justify-content: start;margin-top: 10px;font-size:15px; color: #9197B3;">
                                                        Address Information
                                                    </p>

                                                    <div class="ml-4">
                                                        <a-row :gutter="16">
                                                            <a-col>
                                                                <a-row :style="{ marginBottom: '16px' }">
                                                                    <a-col :span="8">
                                                                        <strong>Region:</strong>
                                                                    </a-col>
                                                                    <a-col :span="12">
                                                                        <div>{{ lead.regionName ? lead.regionName
                                                                            : "N/A" }}</div>
                                                                    </a-col>
                                                                </a-row>
                                                                <a-row :style="{ marginBottom: '16px' }">
                                                                    <a-col :span="8">
                                                                        <strong>Sub Region:</strong>
                                                                    </a-col>
                                                                    <a-col :span="12">
                                                                        <div>{{ lead.districtName ?
                                                                            lead.districtName
                                                                            : "N/A" }}</div>
                                                                    </a-col>
                                                                </a-row>

                                                                <a-row>
                                                                    <a-col :span="8">
                                                                        <strong>Town:</strong>
                                                                    </a-col>
                                                                    <a-col :span="12">
                                                                        <p>
                                                                            {{ lead.communityName ?
                                                                            lead.communityName
                                                                            : "N/A" }}
                                                                        </p>
                                                                    </a-col>
                                                                </a-row>
                                                            </a-col>
                                                        </a-row>
                                                    </div>
                                                </a-col>

                                            </a-row>
                                        </div>
                                    </a-collapse-panel>

                                </a-collapse>
                            </div>
                        </a-card>

                    </a-tab-pane>

                    <a-tab-pane key="1">
                        <span slot="tab">
                            History
                        </span>
                        <div class="requestActions">
                            <a-button @click="exportAllCustomerOrders"
                                style="height:38px;border-raduis:5px; background: #418a49; color:#fff;" icon="export">
                                Export
                            </a-button>
                        </div>
                        <div>
                            <a-table :columns="customerOrdersColumns" :expand-icon-column-index="2"
                                :data-source="tableCustomerHistory" :loading='tableLoading' :pagination="pagination"
                                class="tableStyle">
                                <template slot="dateCreated" slot-scope=''>
                                    <div style="display: flex;padding-top: 4px;justify-content: space-around;">
                                        <p>17-05-2024</p>
                                        <p>--------</p>
                                    </div>
                                </template>
                                <template slot="transaction" slot-scope='data'>
                                    <div
                                        style="display: flex;padding-top: 4px;justify-content: space-around; flex-direction: column;">
                                        <p>{{ data.title }}</p>
                                        <p>{{ data.detail }}</p>
                                        <p>{{ data.by }}</p>
                                    </div>
                                </template>
                                <div slot="expandedRowRender" slot-scope="record">
                                    <p>{{ record.transaction.detail }}</p>
                                </div>

                            </a-table>
                        </div>

                    </a-tab-pane>


                </a-tabs>
            </div>
        </a-card>

        <a-modal class="modalStyle" :visible="updateLeadStatusVisible" :footer="null" @cancel="closeLeadModal">
            <p style="text-align:center;font-weight: bolder;padding-top: 10px;">Update Lead Status</p>
            <div>
                <a-form-model ref="updateLeadRef" :model="updateLeadModel" :rules="rules" layout="horizontal">
                    <a-form-model-item label="Status" ref="status" prop="status">
                        <a-select v-model="updateLeadModel.status" default-value="0">
                            <a-select-option value="0">
                                Lead
                            </a-select-option>
                            <a-select-option value="1">
                                Contacted
                            </a-select-option>
                            <a-select-option value="2">
                                Qualified
                            </a-select-option>
                            <a-select-option value="3">
                                ProposalMade
                            </a-select-option>
                            <a-select-option value="5">
                                Lost
                            </a-select-option>
                            <a-select-option value="6">
                                Fridge
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                </a-form-model>
            </div>

            <div style="display: flex;justify-content: center;padding-top:30px">
                <a-button @click="handleUpdateLeadStatus" :loading="loading"
                    style="background: #418a49;color:#fff;border-radius:5px;">
                    Update
                </a-button>
            </div>
        </a-modal>



        <a-modal :width="700" class="modalStyle" :visible="convertLeadVisible" :footer="null"
            @cancel="closeConvertLeadModal">
            <h3 style="text-align:center;font-weight: bolder;padding-top: 10px;">Convert Lead</h3>
            <div style="padding-top: 20px; display: flex; flex-direction: column;">
                <div>
                    <h4 style="color: #9197B3; font-size: 20px;">Convert Lead</h4>
                    <p style="color: #4C4C4C; font-size: 15px;">{{ lead.firstName && lead.lastName ? lead.firstName + ' ' + lead.lastName : "N/A" }} </p>
                </div>
                <div>
                    <span
                        style="display: flex; justify-content: space-between; align-items: flex-start; width: 40%; padding-top:30px">
                        <h4 style="color: #9197B3; font-size: 15px;">Create New Account</h4>
                        <h4 style="color: #4C4C4C; font-size: 15px;">{{ lead.firstName && lead.lastName ? lead.firstName
                            + ' ' + lead.lastName : "N/A" }}</h4>
                    </span>
                </div>
                <div>
                    <span style="display: flex; justify-content: space-between; align-items: flex-start; width: 40%;">
                        <h4 style="color: #9197B3; font-size: 15px;">Create New Contact</h4>
                        <h4 style="color: #4C4C4C; font-size: 15px;">{{ lead.firstName && lead.lastName ? lead.firstName
                            + ' ' + lead.lastName : "N/A" }}</h4>
                    </span>
                </div>
                <div style="padding-top:30px">
                    <h4 style="color: #9197B3; font-size: 15px;">Owner of the New
                        Records</h4>
                    <p style="color: #4C4C4C; font-size: 15px;">{{ lead.userName ? lead.userName : "N/A" }}</p>
                </div>
            </div>

            <div style="display: flex;justify-content: start;padding-top:30px">
                <a-button @click="handleConvertLead" :loading="loading"
                    style="background: #418a49;color:#fff;border-radius:5px;">
                    Proceed
                </a-button>
                <a-button class="ml-4" @click="closeConvertLeadModal" style="border-radius:5px;">
                    Cancel
                </a-button>
            </div>
        </a-modal>


    </div>

</template>

<script>
import moment from 'moment';
import XLSX from "xlsx";
import _ from 'lodash';
import { mapGetters, mapActions } from 'vuex';


const shopCategoryColumns = [
    {
        title: "Category ID",
        // width: 150,
        dataIndex: 'id',
        key: 'id'
    },
    {
        title: 'RetailCenter Name',
        dataIndex: 'retailCentreName',
        key: 'retailCentreName',
        // width: 130,
    },
    {
        title: 'Product Category',
        dataIndex: 'productCategoryName',
        key: 'productCategoryName',
        //  width: 50,
    },
    {
        title: 'Product Supplier',
        dataIndex: 'productSupplierName',
        key: 'productSupplierName',
        //  width: 50,
    },

    {
        title: 'Product Group',
        dataIndex: 'productGroupName',
        key: 'productGroupName',
        //  width: 50,
    },
    {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        // align: 'center',
        // width: 150,
        scopedSlots: { customRender: 'status' }
    },
    {
        title: 'Date Created',
        dataIndex: 'createdAt',
        key: "createdAt"
    },
    //   {
    //     title: 'Action',
    //     dataIndex: 'action',
    //     align: 'center',
    //     // width: 150,
    //     scopedSlots: { customRender: 'action' }
    //   }

];

const emailColumns = [
    {
        title: 'Subject',
        dataIndex: 'subject',
        key: 'subject',
    },
    {
        title: 'Date',
        dataIndex: 'date',
        key: 'date',
    },
    {
        title: 'Sort By',
        dataIndex: 'sortBy',
        key: 'sortBy',
    },
    {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
    },
]

const activityColumns = [
    {
        title: 'TaskID',
        dataIndex: 'id',
        key: 'subject',
    },
    {
        title: 'Created Date',
        dataIndex: 'date',
        key: 'date',
    },
    {
        title: 'Due Date',
        dataIndex: 'dueDate',
        key: 'dueDate',
    },
    {
        title: 'Order',
        dataIndex: 'order',
        key: 'order',
    },
    {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
    },
]

const activityData = [
    {
        id: 1,
        key: 1,
        date: '12-05-2024',
        dueDate: '12-06-2024',
        order: 'Ben Anim',
        status: 'OPENED'
    },
    {
        id: 2,
        key: 2,
        date: '12-05-2024',
        dueDate: '12-06-2024',
        order: 'Ben Anim',
        status: 'CLOSED'
    },
    {
        id: 3,
        key: 3,
        date: '12-05-2024',
        dueDate: '12-06-2024',
        order: 'Ben Anim',
        status: 'OPENED'
    }
]

const customerOrdersColumns = [
    {
        title: '',
        dataIndex: 'dateCreated',
        key: 'dateCreated',
        scopedSlots: { customRender: 'dateCreated' }
    },
    {
        title: '',
        dataIndex: 'transaction',
        key: 'transaction',
        scopedSlots: { customRender: 'transaction' }
    },

];

const customerColumns = [
    {
        title: 'Customer Name',
        // width: 150,
        key: 'name',
        dataIndex: 'name',
    },
    {
        title: 'Phone Number',
        dataIndex: 'phoneNumber',
        key: 'phoneNumber',
        // width: 150,
    },
    {
        title: 'Address',
        dataIndex: 'address',
        key: 'address',
        // width: 200,
    },


    {
        title: 'Created Date',
        dataIndex: 'createdAt',
        key: 'createdAt',
        // width: 150,
    },

    {
        title: 'Action',
        key: 'action',
        dataIndex: 'action',
        scopedSlots: { customRender: 'action' }
    },
];

const customerInvoiceColumns = [
    {
        title: 'Order Number',
        // width: 150,
        key: 'orderNumber',
        dataIndex: 'orderNumber',
    },
    {
        title: 'Retailer Name',
        dataIndex: 'retailerName',
        key: 'retailerName',
        // width: 150,
    },
    {
        title: 'Distribution Center',
        dataIndex: 'distributionCenter',
        // width: 200,
    },
    {
        title: 'Amount',
        dataIndex: 'amount',
        key: 'amount',
        //  width: 150,
    },

    {
        title: 'Ordered Date',
        dataIndex: 'dateCreated',
        key: 'dateCreated',
        // width: 150,
    },
    {
        title: 'Status',
        key: 'status',
        dataIndex: 'status',
        scopedSlots: { customRender: 'status' }
    },
    {
        title: 'Action',
        key: 'action',
        dataIndex: 'action',
        scopedSlots: { customRender: 'action' }
    },
];

const leadColumns = [
    {
        title: 'lead Name',
        // width: 150,
        key: 'name',
        dataIndex: 'name',
    },
    {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        // width: 150,
    },
    {
        title: 'Phone Number',
        dataIndex: 'phoneNumber',
        key: 'phoneNumber',
        // width: 150,
    },
    {
        title: 'lead Owner',
        dataIndex: 'owner',
        key: 'owner',
        // width: 200,
    },


    {
        title: 'lead Name',
        dataIndex: 'accountName',
        key: 'accountName',
        // width: 150,
    },

    // {
    //     title: 'Action',
    //     key: 'action',
    //     dataIndex: 'action',
    //     scopedSlots: { customRender: 'action' }
    // },
];

const productColumns = [
    {
        title: 'Product Name',
        // width: 150,
        key: 'name',
        dataIndex: 'name',
    },
    {
        title: 'Customer Email',
        dataIndex: 'email',
        key: 'email',
        // width: 150,
    },
    {
        title: 'Authorization',
        dataIndex: 'auth',
        key: 'auth',
        // width: 150,
    },
    {
        title: 'Last Activity',
        dataIndex: 'activity',
        key: 'activity',
        // width: 200,
    },


    {
        title: 'Enablement',
        dataIndex: 'enable',
        key: 'enable',
        // width: 150,
    },

    // {
    //     title: 'Action',
    //     key: 'action',
    //     dataIndex: 'action',
    //     scopedSlots: { customRender: 'action' }
    // },
];


const productData = [
    {
        name: "Aliseryl WS (1kg)",
        email: "Agrodemgad@gmail.com",
        auth: "Authorized",
        activity: "12-05-2024",
        enable: "Enable"
    }
]

const emailData = [
    {
        key: 1,
        id: 1,
        subject: "Agrovet Story",
        date: "24-03-2024",
        sortBy: "Ben Anim",
        status: "Sent"
    },
    {
        key: 2,
        id: 2,
        subject: "Agrovet Story 2",
        date: "24-03-2024",
        sortBy: "Ben Anim 2",
        status: "Sent"
    }
]

const tableCustomerHistory = [
    {
        key: '1',
        dateCreated: '17-05-2024',
        transaction: {
            title: 'Sales Order Updated',
            detail: 'Package created for Sale order AU-000',
            by: 'By Peter'
        }
    },
    {
        key: '2',
        dateCreated: '18-05-2024',
        transaction: {
            title: 'Sales Order Created',
            detail: 'Order created for Sale order AU-001',
            by: 'By John'
        }
    }
]

export default {
    name: 'leadDetails',
    // props: ['items'],
    components: {},
    data() {
        return {
            retailerDetails: {},
            data: [],
            invoiceData: {
                retailerName: '',
                retailerAddress: '',
                dueDate: '',
                cowtribeDate: '',
                invoiceId: '',
                reference: '',
                phoneNumber: '',
                total: '',
                products: [],
            },
            updateLeadModel: {
                status: '',
            },
            activeKey: ['1'],
            labelCol: { span: 8 },
            wrapperCol: { span: 15 },
            tableShopCategories: [],
            tableCustomers: [],
            tableCustomerOrders: [],
            tableCustomerHistory,
            emailData,
            emailColumns,
            tableCustomerInvoices: [],
            availableRetailers: [],
            shopCategoryColumns,
            customerOrdersColumns,
            customerInvoiceColumns,
            productColumns,
            leadColumns,
            productData,
            customerColumns,
            activityColumns,
            activityData,
            dateFormat: 'DD/MM/YYYY',
            startDate: moment(),
            endDate: moment(),
            isEmailOpt: false,
            params: {
                page: -1,
                perPage: -1,
                searchBy: {},
                sortBy: {}
            },
            pagination: {
                pageSize: 20
            },
            id: "",
            lead: {},
            tableLoading: false,
            loading: false,
            isSmsOpt: false,
            isPrimaryOpt: false,
            updateLeadStatusVisible: false,
            convertLeadVisible: false,
            retailerExtraDetails: {},
            
            rules: {
                name: [
                    { required: true, message: 'Please enter name', trigger: 'change' },
                ],
                phoneNumber: [
                    { required: true, message: 'Please enter phoneNumber', trigger: 'change' },

                ],
                status: [
                    { required: true, message: 'Please select option', trigger: 'change' },
                ],
                reference: [
                    { required: true, message: 'Please enter reference', trigger: 'change' },
                ],
                address: [
                    { required: true, message: 'Please enter address', trigger: 'change' },
                ],
            }
        }
    },
    methods: {
        ...mapActions(['getRetailerAndCategoryAndOrders', 'setSubCustomerInfo', 'addSubCustomer']),
        
        onEmailChange(checked) {
            this.isEmailOpt = checked;
        },
        onSmsChange(checked) {
            this.isSmsOpt = checked;
        },
        onPrimaryChange(checked) {
            this.isPrimaryOpt = checked;
        },
        moment,
        closeLeadModal() {
            this.updateLeadStatusVisible = false
        },
        closeConvertLeadModal() {
            this.convertLeadVisible = false;  
        },
        redirectPreviousUrl() {
            this.$router.back();
        },
        showSubCustomerModal() {
            this.updateLeadStatusVisible = true
        },
        showConvertModal() {
            this.convertLeadVisible = true
        },
        showSuccessAlert(message) {
            this.$notification['success']({
                message: message,
            });
        },
        showMoreDetailsModal(data) {
            this.setSubCustomerInfo(data);
            this.$router.push({
                name: 'sub-customer-details',
                params: { id: data?.id }
            }).catch(() => { });
        },
        showLeadStatusModal() {
            this.updateLeadStatusVisible = true;
        },
        async switchEmailStatus() {
            this.tableLoading = true;
        
            const request = {
                id: this.id,
                data: {
                    "emailOpt": this.isEmailOpt,
                }
            } 

            const response = await this.$store.dispatch('pipeline/updateleadStatus', request);

            this.tableLoading = false;
            if (response && response.status === 200) {
                this.showSuccessAlert("Email Option Updated Successfully");
                this.loadleadDetails();
                this.convertLeadVisible = false;
            } else {
                this.showErrorAlert(response && response.data ? response.data.messages : "Oops, something went wrong, try again later");
            }
        },
        
        async switchSmsStatus() {
            this.tableLoading = true;

            const request = {
                id: this.id,
                data: {
                    "smsOpt": this.isSmsOpt
                }
            }

            const response = await this.$store.dispatch('pipeline/updateleadStatus', request);

            this.tableLoading = false;
            if (response && response.status === 200) {
                this.showSuccessAlert("SMS Option Updated Successfully");
                this.loadleadDetails();
                this.convertLeadVisible = false;
            } else {
                this.showErrorAlert(response && response.data ? response.data.messages : "Oops, something went wrong, try again later");
            }
        },

        async switchPrimaryStatus() {
            this.tableLoading = true;

            const request = {
                id: this.id,
                data: {
                    "isPrimary": this.isPrimaryOpt
                }
            }

            const response = await this.$store.dispatch('pipeline/updateleadStatus', request);

            this.tableLoading = false;
            if (response && response.status === 200) {
                this.showSuccessAlert("Lead Primary Option Updated Successfully");
                this.loadleadDetails();
                this.convertLeadVisible = false;
            } else {
                this.showErrorAlert(response && response.data ? response.data.messages : "Oops, something went wrong, try again later");
            }
        },

        

        handleUpdateLeadStatus() {
            this.$refs.updateLeadRef.validate(async valid => {
                if (valid) {
                    this.loading = true;

                    const request = {
                        id: this.id,
                        data: {
                            status: this.updateLeadModel.status
                        }
                    }

                    const response = await this.$store.dispatch('pipeline/updateleadStatus', request);

                    this.loading = false;
                    if (response.status === 200) {
                        this.showSuccessAlert("Lead Status Updated Successfully");
                        this.loadleadDetails();
                        this.updateLeadModel = {
                            status: ''
                        }
                        this.updateLeadStatusVisible = false;
                    } else {
                        this.showErrorAlert(response.data.messages)
                    }
                } else {
                    return false;
                }
            });
        },

        async handleConvertLead() {
            this.loading = true;

            const request = {
                id: this.id,
                data: {
                    status: 4
                }
            }

            const response = await this.$store.dispatch('pipeline/updateleadStatus', request);

            this.loading = false
            if (response.status === 200) {
                this.showSuccessAlert("Lead Converted Successfully");
                this.loadleadDetails();
                this.convertLeadVisible = false;
            } else {
                this.showErrorAlert(response.data.messages)
            }
        },
        showInvoicePreview(data) {
            const retailer = this.availableRetailers.find(retailer => retailer.locationId === data.destinationLocationId)
            if (retailer) {
                this.invoiceData.retailerName = retailer.name
                this.invoiceData.retailerAddress = retailer.address
                this.invoiceData.phoneNumber = retailer.phoneNumber
            }

            this.invoiceData.dueDate = moment(data.createdAt).add(30, 'days').format("Do MMMM, YYYY") // 30 days 
            this.invoiceData.cowtribeDate = moment(data.createdAt).format("Do MMMM, YYYY")
            this.invoiceData.invoiceId = data.id
            this.invoiceData.total = data.total
            this.invoiceData.reference = null
            this.invoiceData.products = data.requestLines.map(product => ({
                id: product.id,
                productName: product.productBrandName,
                quantity: product.quantity,
                unitPrice: product.unitPrice,
                lineTotal: parseInt(product.quantity) * parseFloat(product.unitPrice)
            }))
            this.$refs.invoiceRef.showInvoiceForm(this.invoiceData);
        },

        downloadInvoice(data) {
            const retailer = this.availableRetailers.find(retailer => retailer.locationId === data.destinationLocationId)
            if (retailer) {
                this.invoiceData.retailerName = retailer.name
                this.invoiceData.retailerAddress = retailer.address
                this.invoiceData.phoneNumber = retailer.phoneNumber
            }

            this.invoiceData.dueDate = moment(data.createdAt).add(30, 'days').format("Do MMMM, YYYY") // 30 days 
            this.invoiceData.cowtribeDate = moment(data.createdAt).format("Do MMMM, YYYY")
            this.invoiceData.invoiceId = data.id
            this.invoiceData.total = data.total
            this.invoiceData.reference = null
            this.invoiceData.products = data.requestLines.map(product => ({
                id: product.id,
                productName: product.productBrandName,
                quantity: product.quantity,
                unitPrice: product.unitPrice,
                lineTotal: parseInt(product.quantity) * parseFloat(product.unitPrice)
            }))
            this.$refs.invoiceDownloadRef.downloadInvoice(this.invoiceData);
        },
        showErrorAlert(message) {
            this.$notification['error']({
                message: message
            });
        },
        getRetailerExtraDetails(response) {
            if (response.status === 200) {
                this.retailerExtraDetails = response.data
            } else {
                // console.log("Error | ", response)
            }
        },
        getRetailShopCategories(response) {
            if (response.status === 200) {
                this.tableShopCategories = []
                response.data.data.forEach(category => {
                    this.tableShopCategories.push({
                        id: category.id,
                        key: category.id,
                        retailCentreName: category.retailCentreName,
                        productCategoryName: category.productCategoryName,
                        productSupplierName: category.productSupplierName ? category.productSupplierName : "N/A",
                        productGroupName: category.productGroupName,
                        status: category.shopCategoryStatuseLabel,
                        createdAt: moment(category.createdAt).format("DD-MMM-YYYY"),
                        action: category
                    })
                })
            } else {
                // console.log("Error | ", response)
            }
        },
        getRetailCustomers(response) {
            if (response.status === 200) {
                this.tableCustomers = []
                response.data.data.forEach(customer => {
                    this.tableCustomers.push({
                        id: customer.id,
                        key: customer.id,
                        name: customer.name,
                        phoneNumber: customer.phoneNumber,
                        address: customer.address,
                        createdAt: moment(customer.createdAt).format("DD-MMM-YYYY"),
                        action: customer
                    })
                })
            } else {
                // console.log("Error | ", response)
            }
        },
        getRetailCustomerOrders(response) {
            if (response.status === 200) {
                this.tableCustomerOrders = []
                response.data.data.forEach(order => {
                    this.tableCustomerOrders.push({
                        key: order.id,
                        id: order.id ? `#${order.id}` : 'N/A',
                        orderNumber: order.id ? `#${order.id}` : 'N/A',
                        distributionCenter: order.sourceLocationName ? order.sourceLocationName : 'N/A',
                        retailerName: order.destinationLocationName ? order.destinationLocationName : 'N/A',
                        customerName: order.destinationLocationName ? order.destinationLocationName : 'N/A',
                        amount: order.total ? `Ksh ${order.total.toLocaleString(undefined, { minimumFractionDigits: 2 })}` : 'N/A',
                        dateCreated: moment(order.createdAt).format("DD-MMM-YYYY"),
                        status: order.statusLabel ? order.statusLabel : 'N/A',
                        action: order
                    })
                })
                this.tableCustomerOrders = _.orderBy(this.tableCustomerOrders, ['key'], ['desc'])
            } else {
                // console.log("Error | ", response)
            }
        },

        getRetailCustomerInvoices(response) {
            if (response.status === 200) {
                this.tableCustomerInvoices = []
                response.data.data.forEach(order => {
                    this.tableCustomerInvoices.push({
                        key: order.id,
                        id: order.id ? `#${order.id}` : 'N/A',
                        orderNumber: order.id ? `#${order.id}` : 'N/A',
                        distributionCenter: order.sourceLocationName ? order.sourceLocationName : 'N/A',
                        retailerName: order.destinationLocationName ? order.destinationLocationName : 'N/A',
                        customerName: order.destinationLocationName ? order.destinationLocationName : 'N/A',
                        amount: order.total ? `Ksh ${order.total.toLocaleString(undefined, { minimumFractionDigits: 2 })}` : 'N/A',
                        dateCreated: moment(order.createdAt).format("DD-MMM-YYYY"),
                        status: order.statusLabel ? order.statusLabel : 'N/A',
                        action: order
                    })
                })
                this.tableCustomerInvoices = _.orderBy(this.tableCustomerInvoices, ['key'], ['desc'])
            } else {
                // console.log("Error | ", response)
            }
        },
        getAllRetailers(response) {
            if (response.status === 200) {
                this.availableRetailers = response.data.data
            } else {
                // console.log("Error | ", response)
            }
        },
        exportAllCatgory() {
            const dataToExport = [
                [
                    "Customer ID",
                    "RetailCenter Name",
                    "Product Category",
                    "Product Group",
                    "Status",
                    "Date Created"
                ],
            ];
            this.tableShopCategories.forEach((v) => {
                dataToExport.push([
                    v.id,
                    v.retailCentreName,
                    v.productCategoryName,
                    v.productGroupName,
                    v.status,
                    v.createdAt
                ]);
            });

            var wb = XLSX.utils.book_new();
            var ws = XLSX.utils.aoa_to_sheet(dataToExport);

            /* Add the worksheet to the workbook */
            XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

            /* generate file and send to client */
            XLSX.writeFile(wb, `Export-Customer-Shop-Categories-Data-${moment().format('DD-MM-YYYY')}.xlsx`);
            this.showSuccessAlert("Data Successfully Exported")
        },
        exportAllCustomerOrders() {
            const dataToExport = [
                [
                    "Order ID",
                    "Invoice ID",
                    "Product Name",
                    "Quantity",
                    "Product Category",
                    "RetailCenter Name",
                    "Region",
                    "District Name",
                    "Ordered At",
                ],
            ];
            this.tableCustomerOrders.forEach((v) => {
                dataToExport.push([
                    v.id,
                    v.invoiceId,
                    v.brandName,
                    v.quantity,
                    v.categoryName,
                    v.retailCentreName,
                    v.region,
                    v.districtName,
                    v.orderedAt
                ]);
            });

            var wb = XLSX.utils.book_new();
            var ws = XLSX.utils.aoa_to_sheet(dataToExport);

            /* Add the worksheet to the workbook */
            XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

            /* generate file and send to client */
            XLSX.writeFile(wb, `Export-Customer-Orders-Data-${moment().format('DD-MM-YYYY')}.xlsx`);
            this.showSuccessAlert("Data Successfully Exported")
        },
        async loadRetailerCategoryAndOrders() {
            this.tableLoading = true

            this.params.searchBy['retailCentreId'] = this.retailerDetails.id
            const request_data = {
                retailCenterId: this.retailerDetails.id,
                locationId: this.retailerDetails.locationId,
                payload: {
                    page: 0,
                    perPage: 0,
                    searchBy: {},
                    sortBy: {
                        retailCentreId: this.retailerDetails.id
                    }
                }
            }

            const response = await this.getRetailerAndCategoryAndOrders(request_data)
            this.getRetailerExtraDetails(response[0])
            this.getRetailShopCategories(response[1])
            this.getRetailCustomerOrders(response[2])
            this.getRetailCustomerInvoices(response[2])
            this.getAllRetailers(response[3])
            this.getRetailCustomers(response[4])

            this.tableLoading = false
        },

        async loadleadDetails() {
            this.tableLoading = true;
            const response = await this.$store.dispatch('pipeline/getleadDetails', this.id);
            this.tableLoading = false;
            this.lead = {
                ...response.data,
                createdAt: moment(response.data.createdAt).format("DD/MM/YYYY HH:mm:ss A"),
                closedAt: response.data.closedAt ? moment(response.data.closedAt).format("DD/MM/YYYY HH:mm:ss A") : "N/A",
                salesZone: response.data.salesZone ? response.data.salesZone : "N/A",
            }
        },
    },
    computed: {
        ...mapGetters(['getCustomer']),
        displayDate() {
            return moment(this.retailerExtraDetails.createdAt).format("DD-MMM-YYYY")
        },
        displayTotalShopCategory() {
            return this.tableShopCategories.length
        },
        displayTotalCustomerOrders() {
            return this.tableCustomerOrders.length
        },
        displayTotalCustomer() {
            return this.tableCustomers.length
        },
        showButton() {
            const allowStatus = [0, 1, 2, 3,5,6];
            return allowStatus.includes(this.lead.status) ? true : false;
        }
    },
    created() {
        if (this.$route.params.id) {
            this.id = this.$route.params.id
            this.loadleadDetails();
        }
    }
}
</script>

<style scoped>
.ant-table-wrapper {
    zoom: 1;
    background: #fff;
    margin-bottom: 30px;
}

.tableStyle>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.actionIcons {
    display: flex;
    justify-content: space-around;
    align-items: center;
}

.tableStyle>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
    color: #fff;
}

.tableStyle>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

a {
    color: #777777;
}

a:hover {
    color: #777777;
}

button:hover {
    color: #418a49;
    outline-color: #418a49;
    border-color: #418a49;
}

button {
    color: #418a49;
    outline-color: #418a49;
    border-color: #418a49;
}

.card-container {
    background: #fff;
    overflow: hidden;
    padding: 24px;
}

.card-container>.ant-tabs-card>.ant-tabs-content {
    height: 120px;
    margin-top: -16px;
}

.card-container>.ant-tabs-card>.ant-tabs-content>.ant-tabs-tabpane {
    background: #fff;
    padding: 16px;

}



.card-container>>>.ant-tabs-tab {
    height: 40px;
    margin: 0;
    width: 217px;
    margin-right: 2px;
    padding: 0 16px;
    line-height: 38px;
    background: #fafafa;
    border: 1px solid #e8e8e8;

}

.card-container>>>.ant-tabs-ink-bar {
    position: absolute;
    bottom: 1px;
    left: 0;
    z-index: 1;
    box-sizing: border-box;
    width: 0;
    height: 2px;
    background-color: #98c14b;
    transform-origin: 0 0;
}

.card-container>>>.ant-tabs-tab:hover {
    color: #98c14b;
    /* background: #e5efe7; */
}

.card-container>>>.ant-badge-count {
    z-index: auto;
    min-width: 20px;
    height: 20px;
    padding: 0 6px;
    color: #fff;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    white-space: nowrap;
    text-align: center;
    background: #98c14b;
    border-radius: 10px;
    box-shadow: 0 0 0 1px #fff;
}


.requestActions {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
}

.tableStyle>>>.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
    background: #26A246;
    color: #fff;

}


.tableStyle>>>.ant-table-thead th {
    background: #fff;
    height: 63px;
}

.tableStyle>>>.ant-table-header {
    background: #fff !important;
}

.container {
    display: flex;
    flex-direction: column;
    padding: 20px;
}

.image-text-container {
    display: flex;

    margin-bottom: 20px;
}

.image-container {
    width: 92px;
    height: 92px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #DDDDDD;
}


.img_size {
    max-width: 100%;
    max-height: 100%;
}

.container {
    position: relative;
    display: inline-block;
}

.circular-div {
    width: 92px;
    height: 92px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    position: relative;
    z-index: 1;
}


.circular-div img {
    max-width: 100%;
    max-height: 100%;
    /* Ensure the image scales properly within the circular div */
}

body {
    font-family: Arial, sans-serif;
    margin: 20px;
}

.profile-container {
    display: flex;
    align-items: center;
    gap: 20px;
    /* Space between the image and the details */
}

.profile-picture {
    width: 50px !important;
    height: 50px !important;
    border-radius: 50%;
    overflow: hidden;
    object-fit: cover;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
}

.profile-details {
    display: flex;
    flex-direction: column;
}

.profile-name {
    margin: 0;
    font-size: 12px;
    font-weight: bold;
    color: #1E1E1E
}

.profile-address,
.profile-phone {
    margin: 5px 0 0 0;
    font-size: 12px;
    color: #1E1E1E;
}

.profile-phone {
    display: flex;
    align-items: center;
}

.profile-phone i,
svg {
    margin-right: 10px;
    color: #168d57;
}

.text-overlay {
    position: absolute;
    top: 50%;
    left: 14%;
    transform: translate(-3%, -50%);
    text-align: center;
    z-index: 0;
    /* Place it behind the circular div */
}

.company-name {
    font-size: 23px;
    font-weight: bold;
    color: #1E1E1E;
    width: 70%;
    flex-wrap: wrap;
}

.account-name {
    display: flex;
    font-size: 15px;
    color: #9197B3;
}

.account-name span {
    margin-left: 10px;
    color: #030712;
}

.ant-collapse-borderless {
    background-color: #fff;
    border: 0;
}

.ant-collapse-borderless>.ant-collapse-item {
    border-bottom: none;
}

.ant-switch-checked {
    background-color: #418a49;
}

.card-container >>> .ant-tabs-card > .ant-tabs-bar {
    border: none;
}

.card-container>>>.ant-tabs-card>.ant-tabs-bar .ant-tabs-tab {
    height: 40px;
    color: #111827;
    background: transparent;
    border-radius: 8px;
    max-width: 20%;
    margin-right: 12px;
}


.card-container>>>.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
    height: 40px;
    color: #fff;
    background: #418a49;
    border-bottom: none;
    border-radius: 8px;
    max-width: 20%;
}

@media screen and (min-width: 1020px) and (max-width: 1200px) {
    .text-overlay {
        position: absolute;
        top: 50%;
        left: 40%;
        transform: translate(-50%, -50%);
        text-align: center;
        z-index: 0;
    }

}
</style>